import React, { useEffect, useRef, useState } from "react"
import styled, { createGlobalStyle, keyframes } from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"
import { Col, Container, Row } from "styled-bootstrap-grid"
import { getLocalisedPrice } from "../../services/productHelper"
import {
  getCheckout,
  getItemsCount,
  getReferral,
  isToggleBasket,
} from "../../store/reducers"
import { getCart, getSubTotal, getTotal } from "../../services/cartHelper"
import { connect } from "react-redux"
import { isBrowser } from "../../services/browser"
import BagItem from "./BagItem"
import Engagement from "./Engagement"
import Button from "../Core/Buttons/Button"
import Upsell from "./Upsell"
import OnClickButtonLightGreen from "../Core/Buttons/OnClickButtonLightGreen"
import OnClickButtonGreen from "../Core/Buttons/OnClickButtonGreen"
import CouponPopup from "../../components/Bag/CouponPopup"
import {
  addDiscountAction,
  updateAttributesAction,
} from "../../store/actions/cart/index"
import { Trans, withTranslation } from "gatsby-plugin-react-i18next"
import ArrowLeft from "../../resources/img/ui/arrows/arrow-left-minicart.svg"
import BagLink from "../Core/Header/BagLink"
import {
  createReferralDiscountCode,
  getUserReferralCredit,
  getUserToken,
} from "../../services/user/user"
import { addReferralAction } from "../../store/actions/user"
import GiftBlock from "./GiftBlock"
import { usePromotionContext } from "../../context/PromotionContext"
import { useBlackFridayContext } from "../../context/BlackFridayContext"
import BlackFriday from "./BlackFriday"
import KlarnaWidget from "../Core/KlarnaWidget"
import AlmaWidget from "../Core/AlmaWidget"

const GlobalStyle = createGlobalStyle`
   iframe#chat-button {
     display: none !important;
    }
`

const OpenAnimation = (width) => keyframes`
  0% {
    right: ${width};
  }
  100% {
    right: 0;
  }
`

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background: #0000004d 0% 0% no-repeat padding-box;
  position: fixed;
  z-index: -1;
  display: flex;
  justify-content: flex-end;
  display: ${(props) => (props.open ? "block" : "none")};
  cursor: pointer;
  top: 44px;
  z-index: 999;
  height: calc(100vh - 44px);
  overflow: hidden;

  @media (min-width: ${breakpoints.md}) {
    height: 100%;
    top: 0;
    z-index: 999;
  }
`

const StyledContainer = styled(Container)`
  width: 100%;
  height: 100%;
  background: ${colors.beige};
  padding: ${(props) => props.padding && `92px 0 ${props.padding}px`};
  position: relative;
  cursor: auto;
  animation: ${OpenAnimation("-570px")} 0.3s linear 0s forwards;
  margin-top: -59px;
  @media (min-width: ${breakpoints.sm}) {
    width: 438px;
    margin-right: 0px;
    margin-top: 0;
    animation: ${OpenAnimation("-438px")} 0.3s linear 0s forwards;
    max-height: 100vh;
    padding: ${(props) => props.padding && `38px 0 ${props.padding}px`};
  }
`

const Items = styled.div`
  height: calc(100% - 60px);
  overflow: auto;
`

const YourBag = styled.h2`
  ${fonts.selfModern};
  color: ${colors.trueBlack};
  font-size: 24px;
  line-height: 35px;
  display: inline-block;
`

const TitleSection = styled.div`
  position: relative;
  border-bottom: 1px solid ${colors.newBorderGrey};
  padding-bottom: 24px;
  padding: 0 20px 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${breakpoints.sm}) {
    padding-bottom: 24px;
    padding-left: 34px;
  }
`

const CloseButton = styled.button`
  outline: none;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-right: 30px;
  padding: 0;
  img {
    max-width: 16px;
  }
`

const CheckoutButtonContainer = styled.div`
  width: 100%;
  div,
  button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: ${breakpoints.sm}) {
    div,
    button {
      height: 52px;
    }
  }
`

const CheckoutContainer = styled.div`
  background: ${colors.green};
  position: fixed;
  bottom: 0;
  right: 0;
  height: auto;
  width: 100%;
  max-width: 570px;
  padding: 28px 17px 30px 33px;
  animation: ${OpenAnimation("-570px")} 0.3s linear 0s forwards;
  @media (min-width: ${breakpoints.sm}) {
    animation: ${OpenAnimation("-438px")} 0.3s linear 0s forwards;
    width: 438px;
    margin-right: 0px;
    padding: 34px 25px 30px 39px;
  }
`

const Empty = styled.div`
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  a {
    width: 100% !important;
    max-width: unset !important;
  }
`

const EmptyBagMessage = styled.p`
  margin-bottom: 45px;
  margin-top: 12px;
  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 38px;
    margin-top: 24px;
  }
`

const Total = styled.div`
  width: 100%;
  margin-bottom: 13px;
`

const GiftSection = styled.div`
  margin: 14px auto 10px;
`

const PromoSection = styled.div`
  padding: 18px 22px 23px 32px;
`

const UnderlinedButton = styled.div`
  ${fonts.helveticaNeueCondensedBold};
  letter-spacing: 0.82px;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => (props.$white ? colors.white : colors.trueBlack)};
  text-decoration: underline;
  cursor: pointer;
`

const Textarea = styled.textarea`
  ${fonts.helveticaNeueLight};
  border: 1px solid ${colors.newBorderGrey};
  font-size: 12px;
  line-height: 19px;
  color: ${colors.textGrey};
  min-height: 88px;
  outline: none;
  padding: 8px;
  width: 100%;
  background: ${colors.white};
  resize: none;
  margin-top: 14px;
`

const PromoDropdown = styled.div`
  display: flex;
  margin: 14px 0 0;
  position: relative;
`

const PromoInput = styled.input`
    background-color: transparent !important;    
    ${fonts.helveticaNeueLight};
    border: none;
    border-radius: 0;
    border-bottom: 1px solid ${colors.greyBorders};
    color: ${colors.black};
    font-size: 13px;
    line-height: 18px;
    padding-left: 0px;
    width: 100%;
    height: 38px;
    box-sizing: border-box;
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        outline: none;
        box-shadow: none;
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        ${fonts.helveticaNeueLight};
        color: ${colors.greyPlaceHolder};
        font-size: 13px;
        line-height: 18px;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        ${fonts.helveticaNeueLight};
        color: ${colors.greyPlaceHolder};
        font-size: 13px;
        line-height: 18px;
    }
    :-ms-input-placeholder { /* IE 10+ */
        ${fonts.helveticaNeueLight};
        color: ${colors.greyPlaceHolder};
        font-size: 13px;
        line-height: 18px;
    }
    :-moz-placeholder { /* Firefox 18- */
        ${fonts.helveticaNeueLight};
        color: ${colors.greyPlaceHolder};
        font-size: 13px;
        line-height: 18px;
    }
    :-webkit-autofill,
    :-webkit-autofill:hover, 
    :-webkit-autofill:focus, 
    :-webkit-autofill:active  {
        -webkit-box-shadow: 0 0 0 22px ${colors.beige} inset !important;
    }
    :-webkit-autofill {
        -webkit-text-fill-color: ${colors.black} !important;
        ${fonts.helveticaNeueLight};
        color: ${colors.black};
        font-size: 13px;
        line-height: 18px;
    }
    }

`

const ApplyContainer = styled.div`
  margin-left: 10px;
  div,
  button {
    height: 38px;
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
const PriceWrapper = styled.div`
  ${fonts.helveticaNeueCondensedBold};
  color: ${colors.white};
  display: flex;
  justify-content: space-between;
  width: 100%;
  & > div {
    text-transform: uppercase;
    display: flex;
    width: auto;
    &:first-of-type {
      padding-right: 10px;
    }
  }
`

const Prices = styled.div`
  position: relative;
`

const Price = styled.div`
  color: ${(props) => (props.$crossed ? colors.black : colors.white)};
  font-style: ${(props) => (props.$crossed ? "italic" : "normal")};
  position: ${(props) => (props.$crossed ? "absolute" : "static")};
  bottom: ${(props) => props.$crossed && "0"};
  transform: ${(props) => props.$crossed && "translateY(100%)"};
  font-size: ${(props) => (props.$crossed ? "14px" : "18px")};
  display: flex;
  & > div {
    position: relative;
    display: block;
  }
`

const Line = styled.div`
  position: absolute;
  width: 110% !important;
  border-top: 2px solid ${colors.black};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
`

const CouponText = styled.div`
  ${fonts.helveticaNeueLight};
  font-size: 10px;
  line-height: 16px;
  color: ${(props) => (props.error ? colors.errorRed : colors.textGrey)};
  margin: 14px auto 0;
`

const CouponTextBlue = styled.div`
  ${fonts.helveticaNeueLight};
  font-style: italic;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.68px;
  color: ${colors.black};
  min-height: 17px;
  max-width: 280px;
`

const GiftOptionsContainer = styled(Row)`
  margin-top: 10px;
  width: 100%;
  padding-bottom: 7px;
  @media (min-width: ${breakpoints.md}) {
    margin-top: 8px;
    padding-bottom: 5px;
  }
`

const Checkbox = styled.label`
  ${fonts.helveticaNeueLight};
  color: ${colors.white};
  font-size: 12px;
  line-height: 20px;
  padding-left: 24px;
  margin-right: 15px;
  position: relative;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    width: 14px;
    background-color: ${colors.white};
    cursor: pointer;
    transform: translateY(-50%);
  }
  .checkmark:before,
  .checkmark:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 9px;
    height: 9px;
    transform: translate(-50%, -50%);
  }
  .checkmark:before {
    background-color: ${colors.white};
  }
  .checkmark:after {
    display: none;
  }
  input:checked ~ .checkmark:after {
    display: block;
  }
  .checkmark:after {
    background-color: ${colors.green};
  }
  @media (min-width: ${breakpoints.md}) {
    display: flex;
    justify-content: center;
    align-items: center;
    .checkmark {
      height: 18px;
      width: 18px;
    }
    .checkmark:before,
    .checkmark:after {
      width: 12px;
      height: 12px;
    }
  }
`

const MessageLength = styled.div`
  ${fonts.helveticaNeue};
  color: ${colors.white};
  font-size: 11px;
  line-height: 11px;
  display: block;
  width: 100%;
  text-align: right;
  margin-top: 2px;
`

const WidgetContainer = styled.div`
  margin-top: 12px;
`

const WRAP_TOGETHER = "bag.wrap_together"
const WRAP_SEPARATELY = "bag.wrap_separately"

function MiniCart(props) {
  const { t } = props
  let hasItems = false
  let bagItems = []
  let cartData
  let cart
  let couponCode
  let groupedByUniqueStyleName
  let sortedBySameOption = []
  let filtered = []
  let groupedBagItems = []
  let excludeKeys = [
    t("pdp.engraving"),
    `${t("pdp.engraving")} - ${t("pdp.engraving.back")}`,
    "Font Style",
  ]
  let setItems = []
  let checkoutUrl
  let checkoutContainerRef = useRef(null)
  let discountEligibleOnAllProducts = true
  const [checkoutHeight, setCheckoutHeight] = useState(0)
  const [message, setMessage] = useState("")
  const [isMessageOpen, setIsMessageOpen] = useState(false)
  const [isCouponOpen, setIsCouponOpen] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [couponCodeInput, setCouponCodeInput] = useState(null)
  const [width, setWidth] = useState(0)
  const [error, setError] = useState(false)

  const [wrappingOption, setWrappingOption] = useState(WRAP_TOGETHER)

  const itemsWrapperRef = useRef(null)

  const handleResize = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    if (isBrowser()) {
      setWidth(window.innerWidth)
    }
  }, [])

  useEffect(() => {
    if (isBrowser()) {
      window.addEventListener("resize", handleResize)
    }
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (checkoutContainerRef) {
      setCheckoutHeight(checkoutContainerRef.clientHeight)
    }
  }, [])

  useEffect(() => {
    if (cart && !cart.couponCode) {
      let friendCode = sessionStorage.getItem("friendCode")
      if (!friendCode) {
        checkReferralCredits()
      } else {
        applyReferralCoupon(friendCode)
      }
    }
    if (cart) {
      couponCode = cart.couponCode
    }
  }, [cart])

  if (isBrowser()) {
    cartData = getCart()
  }

  let appliedGiftCards = []
  let appliedGiftCardsBalance = 0
  if (cartData) {
    cart = JSON.parse(cartData)
    couponCode = cart.couponCode
    hasItems = cart.items.length > 0
    checkoutUrl = cart.checkoutUrl
    appliedGiftCards = cart.appliedGiftCards
    appliedGiftCardsBalance = appliedGiftCards.reduce((acc, item) => {
      return acc + Number(item.amountUsed.amount)
    }, 0)

    if (cart && cart.items) {
      discountEligibleOnAllProducts = cart.items.every(
        (item) => Number(item.discountAmount) > 0
      )
      cart.items.forEach((item) => {
        const customAttributes = item.customAttributes
        if (customAttributes) {
          customAttributes.forEach(
            (custom) => custom.key === "Set" && setItems.push(item)
          )
        }
      })
      cart.items.reduce((set, item) => {
        let isSet =
          item.customAttributes.length > 0 &&
          item.customAttributes.filter((custom) => custom.key === "Set")[0]
        let value = isSet && isSet.value
        let setItem = []
        cart.items.forEach((item) => {
          if (item.customAttributes.length > 0) {
            item.customAttributes.filter(
              (custom) => custom.value === value && setItem.push(item)
            )
          }
        })
        if (setItem.length === 0) {
          setItem.push(item)
        }
        return bagItems.push(setItem)
      }, [])
    }
  } else {
    bagItems = []
  }

  if (bagItems.length > 0) {
    groupedByUniqueStyleName = Array.from(
      new Set(bagItems.map(JSON.stringify)),
      JSON.parse
    )
  }

  if (groupedByUniqueStyleName && groupedByUniqueStyleName.length > 0) {
    for (let i = 0; i < groupedByUniqueStyleName.length; i++) {
      const itemNames = []
      const options = []
      let sets = groupedByUniqueStyleName[i]
      const setItems = [sets]
      let isSet =
        sets[0].customAttributes.length > 0 &&
        sets[0].customAttributes.filter((custom) => custom.key === "Set")[0]
      const currentStyle = isSet && isSet.value.replace(/[0-9.]/g, "")
      const hasEngraving =
        sets[0].customAttributes.length > 0 &&
        sets[0].customAttributes.filter((custom) =>
          excludeKeys.includes(custom.key)
        )
      const engravingTexts = []
      const engravingKeyLists = []
      sets.forEach((single) =>
        options.push(...single.selectedOptions.map((option) => option.value))
      )
      sets.forEach((single) => itemNames.push(single.title))
      if (hasEngraving) {
        hasEngraving.forEach(
          (engraving) =>
            engravingTexts.push(engraving.value) &&
            engravingKeyLists.push(engraving.key)
        )
      }

      let current = [
        ...itemNames,
        ...options,
        currentStyle,
        ...engravingTexts,
        ...engravingKeyLists,
      ]
        .sort()
        .join(",")
      groupedByUniqueStyleName.forEach((item, index) => {
        if (index !== i) {
          const nextItemNames = []
          const nextOptions = []
          let set = item
          let isSet =
            set[0].customAttributes.length > 0 &&
            set[0].customAttributes.filter((custom) => custom.key === "Set")[0]
          const nextStyle = isSet && isSet.value.replace(/[0-9.]/g, "")
          const hasEngraving =
            set[0].customAttributes.length > 0 &&
            set[0].customAttributes.filter((custom) =>
              excludeKeys.includes(custom.key)
            )
          const engravingTexts = []
          const engravingKeyLists = []
          set.forEach((single) =>
            nextOptions.push(
              ...single.selectedOptions.map((option) => option.value)
            )
          )
          set.forEach((single) => nextItemNames.push(single.title))
          if (hasEngraving) {
            hasEngraving.forEach(
              (engraving) =>
                engravingTexts.push(engraving.value) &&
                engravingKeyLists.push(engraving.key)
            )
          }
          let next = [
            ...nextItemNames,
            ...nextOptions,
            nextStyle,
            ...engravingTexts,
            ...engravingKeyLists,
          ]
            .sort()
            .join(",")
          return next === current && setItems.push(item, next)
        }
      })
      sortedBySameOption.push(setItems)
    }
  }

  sortedBySameOption.forEach((item) => {
    if (item.length === 1) {
      return groupedBagItems.push(...item)
    }
    if (item.length > 1) {
      const withOutString = item.filter((value) => Array.isArray(value))
      return (
        !filtered.includes(item[item.length - 1]) &&
        filtered.push(item[item.length - 1]) &&
        groupedBagItems.push(withOutString)
      )
    }
  })

  const initiateCheckout = (url) => {
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
    const localisedUrl = activeEnv !== "fr" ? url : `${url}&locale=${activeEnv}`

    if (isBrowser()) {
      let gtag = window.gtag
      let cartItemsData = []

      if (cart && cart.items) {
        cartItemsData = cart.items.map((item) => {
          let dataObj = {
            id: item.variantId.replace("gid://shopify/ProductVariant/", ""),
            name: item.title,
            quantity: item.quantity,
            price: item.price.amount,
          }
          return dataObj
        })
      }

      if (typeof gtag === "function") {
        gtag("event", "initiate_checkout", {
          items: cartItemsData,
          coupon: couponCode || "",
        })
      }
    }

    setTimeout(function () {
      window.location.href = localisedUrl
    }, 1)
  }

  const handleCheckout = (url) => {
    let note = `${t(wrappingOption)}`

    if (message && message.length > 1) {
      note = note + ` | ${t("bag.personal_note")}: ${message}`
    }

    let updateNote = props.updateAttributesAction(note)
    updateNote &&
      updateNote.then(() => {
        initiateCheckout(url)
      })
  }

  const checkReferralCredits = () => {
    const token = getUserToken()
    if (!token) {
      return
    }

    if (!props.referral) {
      getUserReferralCredit()
        .then((creditResult) => {
          const credit = creditResult.data.credit
          if (credit !== 0) {
            createReferralDiscountCode().then((codeResult) => {
              const code = codeResult.data.code
              applyReferralCoupon(code)
            })
          }
        })
        .catch((error) => {
          console.error(error)
          return
        })
    } else {
      const { credit } = props.referral
      if (credit !== 0) {
        createReferralDiscountCode()
          .then((codeResult) => {
            const code = codeResult.data.code
            applyReferralCoupon(code)
          })
          .catch((error) => {
            console.error(error)
          })
      }
    }
  }

  const applyReferralCoupon = (referralCode) => {
    let addDiscount = props.addDiscountAction(referralCode)
    addDiscount &&
      addDiscount.then(({ isCodeValid, error }) => {
        if (!isCodeValid) {
          setError(error)
        } else {
          setError("")
        }
      })
  }

  const applyCoupon = () => {
    let addDiscount = props.addDiscountAction(couponCodeInput?.trim())
    addDiscount &&
      addDiscount.then(({ isCodeValid, error }) => {
        if (!isCodeValid) {
          setError(error)
        } else {
          setError("")
        }
      })
  }

  // useEffect(() => {
  //   if (!isCouponApplied && !props.cart.isAdded) {
  //     setIsPopupOpen(true)
  //   }
  // }, [isCouponApplied])

  const giftOptions = [{ value: WRAP_TOGETHER }, { value: WRAP_SEPARATELY }]
  let fixedItemsCount = props.itemsCount - setItems.length / 2

  let total = 0
  let hasDiscount = false

  if (hasItems) {
    total = getTotal(cart)
    hasDiscount = Number(total) > Number(cart.paymentDue.amount)
  }

  const { checkIfFreeGiftActive, checkIfPromotionActive } =
    usePromotionContext()

  const { isBlackFriday } = useBlackFridayContext()

  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development"

  return (
    <Overlay onClick={() => props.handleOpen(false)} open={props.open}>
      <GlobalStyle />
      <StyledContainer
        onClick={(e) => e.stopPropagation()}
        padding={checkoutHeight}
      >
        <TitleSection
          onClick={() => setIsMessageOpen(false)}
          padding={checkoutHeight}
        >
          <div>
            <CloseButton onClick={() => props.handleOpen(false)}>
              <img src={ArrowLeft} alt="Close mini cart button" />
            </CloseButton>
            <YourBag>{t("minicart.your_bag")}</YourBag>
          </div>
          {width >= 576 && (
            <BagLink
              minicart
              cartOpen={props.open}
              setCartOpen={props.handleOpen}
            />
          )}
        </TitleSection>
        {hasItems ? (
          <Items ref={itemsWrapperRef} onClick={() => setIsMessageOpen(false)}>
            {groupedBagItems.map((item, index) => {
              const items = item.flat()
              let isEngagement = false
              items.forEach((single) => {
                let engagement = false
                if (single.customAttributes && !engagement) {
                  single.customAttributes.forEach((attr) => {
                    if (attr.key === "Set") {
                      engagement = true
                    }
                  })
                }

                if (engagement) {
                  isEngagement = true
                }
              })

              return isEngagement ? (
                <Engagement bagItem={item} key={index} />
              ) : (
                items.map((item, index) => {
                  const isGift =
                    checkIfPromotionActive() && item.discountAmount > 0
                  const productGallery = items.find((i) => i.image)?.image
                  const totalQuantity = items.reduce((total, curr) => {
                    const quantity = total + curr.quantity

                    return quantity
                  }, 0)

                  return (
                    <BagItem
                      bagItem={item}
                      gift={isGift ? true : false}
                      productGallery={productGallery}
                      totalQuantity={totalQuantity}
                      key={index}
                    />
                  )
                })
              )
            })}

            {checkIfPromotionActive() && !checkIfFreeGiftActive() && (
              <GiftBlock />
            )}

            <PromoSection>
              <UnderlinedButton onClick={() => setIsCouponOpen(!isCouponOpen)}>
                + {t("minicart.apply_promo_code")}
              </UnderlinedButton>
              {isCouponOpen && (
                <React.Fragment>
                  <PromoDropdown>
                    <PromoInput
                      type={"text"}
                      value={couponCodeInput ? couponCodeInput : ""}
                      onChange={(e) => setCouponCodeInput(e.target.value)}
                    />
                    <ApplyContainer>
                      <OnClickButtonGreen onClick={(e) => applyCoupon(e)}>
                        {t("bag.apply")}
                      </OnClickButtonGreen>
                    </ApplyContainer>
                    <CouponPopup
                      handlePopup={setIsPopupOpen}
                      open={isPopupOpen}
                      freeGiftActive={checkIfFreeGiftActive()}
                    />
                  </PromoDropdown>
                  {couponCode && error === "" ? (
                    hasDiscount && discountEligibleOnAllProducts ? (
                      <CouponText>
                        <Trans i18nKey={"bag.promo_code_added"}>
                          Promo Code {couponCode} applied successfully. The
                          discount has been applied to your bag.
                        </Trans>
                      </CouponText>
                    ) : (
                      <CouponText>
                        <Trans i18nKey={"bag.promo_code_error"}>
                          Promo Code {couponCode} discount code applied
                          successfully but isn’t valid for all the items in your
                          cart.
                        </Trans>
                      </CouponText>
                    )
                  ) : null}
                  {error ? <CouponText error>{error}</CouponText> : null}
                </React.Fragment>
              )}
            </PromoSection>
            {isBlackFriday ? <BlackFriday /> : <Upsell t={t} />}
          </Items>
        ) : (
          <Empty>
            <EmptyBagMessage>{t("bag.empty")}</EmptyBagMessage>
            <Button to={"/shop-jewelry"}>
              {t("minicart.continue_shopping")}
            </Button>
          </Empty>
        )}
        <CheckoutContainer ref={(ref) => (checkoutContainerRef = ref)}>
          {hasItems && (
            <>
              <Total>
                <PriceWrapper>
                  <div>{t("minicart.estimated_total")}</div>
                  <Prices>
                    <Price>
                      {getLocalisedPrice(
                        getSubTotal(cart),
                        cart.currencyCode,
                        true
                      )}
                    </Price>
                    {hasDiscount && (
                      <Price $crossed={hasDiscount ? 1 : 0}>
                        <div>
                          {getLocalisedPrice(total, cart.currencyCode, true)}
                          {hasDiscount && <Line></Line>}
                        </div>
                      </Price>
                    )}
                  </Prices>
                </PriceWrapper>
                <CouponTextBlue>
                  {couponCode && appliedGiftCards.length === 0 && (
                    <Trans i18nKey={"bag.promo_code_added_total"}>
                      Promo Code {couponCode} applied.
                    </Trans>
                  )}
                  {appliedGiftCards.length > 0 && !couponCode && (
                    <>
                      Gift card balance{" "}
                      {getLocalisedPrice(
                        appliedGiftCardsBalance,
                        cart.currencyCode
                      )}{" "}
                      applied
                    </>
                  )}
                  {appliedGiftCards.length > 0 && couponCode && (
                    <>
                      Promo Code {couponCode} and gift card balance{" "}
                      {getLocalisedPrice(
                        appliedGiftCardsBalance,
                        cart.currencyCode
                      )}{" "}
                      applied.
                    </>
                  )}
                </CouponTextBlue>
              </Total>
              <GiftSection>
                <UnderlinedButton
                  $white
                  onClick={() => setIsMessageOpen(!isMessageOpen)}
                >
                  {t("minicart.gift")}
                </UnderlinedButton>
                {isMessageOpen && (
                  <React.Fragment>
                    <Textarea
                      id="personalNote"
                      name="personalNote"
                      type="text"
                      role="textbox"
                      onChange={(e) => setMessage(e.target.value)}
                      maxLength="193"
                    />
                    <MessageLength>
                      {message.length}/193 {t("pdp.characters")}
                    </MessageLength>
                    {/* black friday */}
                    {fixedItemsCount > 1 && (
                      <GiftOptionsContainer>
                        {giftOptions.map((option, index) => {
                          const { value } = option
                          return (
                            <Col xs="auto" sm="auto" key={index}>
                              <Checkbox>
                                <input
                                  type="radio"
                                  name={"gift-list"}
                                  id={value}
                                  value={value}
                                  checked={wrappingOption === value}
                                  onChange={() => setWrappingOption(value)}
                                />
                                <div className="checkmark" />
                                {t(value)}
                              </Checkbox>
                            </Col>
                          )
                        })}
                      </GiftOptionsContainer>
                    )}
                  </React.Fragment>
                )}
              </GiftSection>
              <CheckoutButtonContainer>
                <OnClickButtonLightGreen
                  onClick={() => handleCheckout(checkoutUrl)}
                >
                  {t("bag.checkout")}
                </OnClickButtonLightGreen>
              </CheckoutButtonContainer>

              <WidgetContainer>
                {(activeEnv === "us" ||
                  activeEnv === "uk" ||
                  activeEnv === "development") && (
                  <KlarnaWidget price={total * 100} white={true} />
                )}
                {(activeEnv === "fr" ||
                  activeEnv === "eu" ||
                  activeEnv === "development") && (
                  <AlmaWidget price={total * 100} white={true} />
                )}
              </WidgetContainer>
            </>
          )}
        </CheckoutContainer>
      </StyledContainer>
    </Overlay>
  )
}

const mapStateToProps = (state) => {
  return {
    cart: getCheckout(state),
    itemsCount: getItemsCount(state),
    isToggleBasket: isToggleBasket(state),
    referral: getReferral(state),
  }
}

const mapDispatchToProps = {
  addDiscountAction,
  updateAttributesAction,
  addReferralAction,
}

const TranslatedMiniCartPage = withTranslation()(MiniCart)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslatedMiniCartPage)
